import { getErrorDetail } from "components/utility/utils";
import { fetchOrchidAPI } from "utils/api";

/**
 * Orchid Pro creates unavailability series
 */
export default async function postBlockedIntervalSeries(
  arg: BlockedIntervalSeriesInput,
): Promise<{
  unavailability_series: BlockedIntervalSeriesMetaData;
  unavailabilities_created: BlockedIntervalWithSeriesInfo[];
}> {
  const res = await fetchOrchidAPI("/api/scheduler/v1/unavailability/series", {
    headers: { "content-type": "application/json" },
    body: JSON.stringify(arg),
    method: "POST",
  });
  if (!res.ok) {
    throw new Error(
      `failed to post unavailability series: ${getErrorDetail(await res.text())}`,
    );
  }
  return res.json();
}
